import breakpoints from "./breakpoints";
import colors from "./colors";

const theme = {
  colors,
  breakpoints,
};

export default theme;
